import React, { useEffect, useRef, useState } from "react";
import ModalDefault from "../../modalDefault";
import { DataTable } from "mantine-datatable";
import { toast } from "react-hot-toast";
import {
  ApiDeleteDiaInactivo,
  ApiGetAllDiaInactivos,
} from "../../../api/diasInactivos";
import { ActionIcon, Group, MultiSelect } from "@mantine/core";

const BATCH_SIZE = 15;

const TablaDiasInactivos = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [allDiasInactivos, setAllDiasInactivos] = useState([]);
  const [filteredDiasInactivos, setFilteredDiasInactivos] = useState([]);
  const [fetching, setfetching] = useState(true);
  const [selectedDiaInactivo, setSelectedDiaInactivo] = useState(null);

  // Estados para scroll infinito y filtros
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadedRecords, setLoadedRecords] = useState(BATCH_SIZE);
  const [selectedPeriodos, setSelectedPeriodos] = useState([]);
  const [queryFechaInactividad, setQueryFechaInactividad] = useState("");
  const scrollViewportRef = useRef(null);

  //ordenamiento
  const [isInit, setIsInit] = useState(false);
  const [sortStatus, setSortStatus] = useState({
    columnAccessor: "",
    direction: "asc",
  });

  const columns = [
    {
      accessor: "pre_periodos.nombre",
      title: "Periodo",
      textAlignment: "center",
      filter: (
        <MultiSelect
          data={
            // si no hay periodos, se muestra un array vacío para evitar errores
            props.listadoPeriodos.map((periodo) => ({
              value: periodo.pre_periodo_id,
              label: periodo.nombre,
            })) || []
          }
          placeholder="Filtrar por periodo..."
          value={selectedPeriodos}
          onChange={(values) => {
            setSelectedPeriodos(values);
          }}
        />
      ),
      filtering: selectedPeriodos.length > 0,
    },
    {
      accessor: "fecha",
      title: "Fecha de inactividad",
      textAlignment: "center",
      sortable: true,
    },
    {
      accessor: "acciones",
      title: "Acciones",
      textAlignment: "center",
      render: (record) => opciones(record),
    },
  ];

  useEffect(() => {
    init();
  }, [props.updateList]);

  const init = async () => {
    setfetching(true);
    const { data } = await ApiGetAllDiaInactivos();
    const filterDiaInactivos = data.filter(
      // Para recuperar solo los dias que pertenecen a periodos no eliminados
      // (diaInactivo) => diaInactivo.estado !== false && props.listadoPeriodos.some(periodo => periodo.pre_periodo_id === diaInactivo.pre_periodo_id && periodo.estado === true)
      // Recupera todos los dias inactivos, incluso de periodos eliminados
      (diaInactivo) => diaInactivo.estado !== false
    );
    setAllDiasInactivos(filterDiaInactivos);
    setFilteredDiasInactivos(filterDiaInactivos);
    setfetching(false);
    setIsInit(true);
  };

  //logica para manejar los filtros
  useEffect(() => {
    const queryFechaInactividadLower = queryFechaInactividad.toLowerCase();

    const selectedPeriodosSet = new Set(selectedPeriodos);
    const isPeriodoSelected = (diaInactivo) =>
      selectedPeriodos.length === 0 ||
      selectedPeriodosSet.has(diaInactivo.pre_periodo_id);

    const filteredDiasInactivos = allDiasInactivos.filter((diaInactivo) => {
      return (
        diaInactivo.fecha.toLowerCase().includes(queryFechaInactividadLower) &&
        isPeriodoSelected(diaInactivo)
      );
    });
    setFilteredDiasInactivos(filteredDiasInactivos);
  }, [allDiasInactivos, selectedPeriodos, queryFechaInactividad]);

  //logica para manejar el ordenamiento
  useEffect(() => {
    if (!isInit) return;
    if (sortStatus.columnAccessor === "fecha") {
      const sortedRecords = [...allDiasInactivos].sort((a, b) => {
        const fechaA = new Date(a.fecha);
        const fechaB = new Date(b.fecha);
        return fechaA - fechaB;
      });

      if (sortStatus.direction === "desc") {
        setAllDiasInactivos(sortedRecords.reverse());
      } else {
        setAllDiasInactivos(sortedRecords);
      }
    }
  }, [sortStatus]);

  // Carga más datos cuando se llega al final del scroll
  const loadMoreData = () => {
    if (loadedRecords < filteredDiasInactivos.length) {
      setLoadingMore(true);
      setTimeout(() => {
        setLoadedRecords(loadedRecords + BATCH_SIZE);
        setLoadingMore(false);
      }, 1000);
    }
  };

  const visibleDiasInactivos = filteredDiasInactivos.slice(
    0,
    Math.min(loadedRecords, filteredDiasInactivos.length)
  );

  const editDiaInactivo = (row) => {
    const { fecha, pre_dia_inactivo_id, pre_periodo_id } = row;
    props.setType("editar");
    props.setState({
      ...props.state,
      pre_periodo_id,
      fecha,
      pre_dia_inactivo_id,
    });
  };

  const onShowModal = (e) => {
    setShowModal(true);
    setSelectedDiaInactivo(e);
  };

  const onClosedModal = () => {
    setShowModal(false);
    setSelectedDiaInactivo(null);
  };

  const onDelete = async () => {
    const { estado, pre_dia_inactivo_id } = selectedDiaInactivo;
    const { sms, mensaje } = await ApiDeleteDiaInactivo({
      pre_dia_inactivo_id,
      estado: !estado,
    });
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setSelectedDiaInactivo(null);
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    onClosedModal();
  };

  const opciones = (row) => {
    return (
      <Group spacing={4} position="center" noWrap>
        <ActionIcon
          color="blue"
          onClick={() => {
            editDiaInactivo(row);
          }}
        >
          <i className="fas fa-file-pen"></i>
        </ActionIcon>
        <ActionIcon
          color="red"
          onClick={() => {
            onShowModal(row);
          }}
        >
          <i className="fas fa-trash"></i>
        </ActionIcon>
        <ModalDefault
          bandera={"confirmacion"}
          modal={showModal}
          size={"sm"}
          icontitulo={<null />}
          titulo={`Confirmación`}
          closeAction={onClosedModal}
        >
          <div className="row py-4 justify-content-center text-align-center ">
            Realmente desea eliminar
          </div>
          <div className="d-flex justify-content-end flex-row align-self-start my-4">
            <button
              type=""
              onClick={onClosedModal}
              className="bg-btn-vet-danger sombra mx-1"
            >
              Cancelar
            </button>
            <button
              type=""
              onClick={onDelete}
              className="bg-btn-vet sombra mx-1"
            >
              <i className="fas fa-save"> Eliminar</i>
            </button>
          </div>
        </ModalDefault>
      </Group>
    );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <DataTable
          borderRadius="md"
          className="bordecompleto bgfondo "
          highlightOnHover
          noRecordsText="No se encontraron datos"
          columns={columns}
          totalRecords={allDiasInactivos.length}
          withColumnBorders
          records={visibleDiasInactivos}
          fetching={fetching || loadingMore}
          onScrollToBottom={loadMoreData}
          scrollViewportRef={scrollViewportRef}
          style={{ maxHeight: "350px", overflowY: "auto" }}
          sortStatus={sortStatus}
          onSortStatusChange={setSortStatus}
        />
      </div>
    </div>
  );
};

export default TablaDiasInactivos;
